import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function

const createNewPhoto = async (
  folderid,
  token,
  title,
  description,
  docid,
  prefix
) => {
  // Define the endpoint URL
  const url = `${prefix}folders/${folderid}/documents/${docid}/photo`;

  // Define the request body
  const body = {
    folderid: folderid,
    title: title,
    description: description,
    docid: docid || "",
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const reponseText = await response.text();

    // Check if the request was successful
    if (response.ok) {
      const responseData = JSON.parse(reponseText);
      const id = responseData.id || "ID";
      return id;
    } else {
      console.error(`Failed to create photo: ${response.status}`);
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default createNewPhoto;
